/**
 * @generated SignedSource<<e80cadeec0148b12d0e7441129b597e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type customTemplateBusinessProjectBanner_businessHorizontalNav$data = {
  readonly isLiveTemplate: boolean | null | undefined;
  readonly " $fragmentType": "customTemplateBusinessProjectBanner_businessHorizontalNav";
};
export type customTemplateBusinessProjectBanner_businessHorizontalNav$key = {
  readonly " $data"?: customTemplateBusinessProjectBanner_businessHorizontalNav$data;
  readonly " $fragmentSpreads": FragmentRefs<"customTemplateBusinessProjectBanner_businessHorizontalNav">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "customTemplateBusinessProjectBanner_businessHorizontalNav",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLiveTemplate"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b53840460a785858a03465e2d4e8a922";

export default node;
